import { render, staticRenderFns } from "./likes-comp.vue?vue&type=template&id=01d78645&scoped=true&"
import script from "./likes-comp.vue?vue&type=script&lang=js&"
export * from "./likes-comp.vue?vue&type=script&lang=js&"
import style0 from "./likes-comp.vue?vue&type=style&index=0&id=01d78645&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d78645",
  null
  
)

export default component.exports